import { useNavigate } from 'react-router-dom';

export default function Landing() {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen w-screen bg-background dark:from-neutral-900 dark:to-neutral-800 flex items-start justify-center">
      <article className="w-full min-h-screen bg-card dark:bg-neutral-900/80 border border-border dark:border-neutral-700 p-6 sm:p-10 flex flex-col gap-8 ">
        <header className="flex flex-1 flex-col gap-4 items-start text-left">
          <div className="flex gap-3 items-center">
            <img
              alt="Logo Novus CFC"
              src="/LogoNovusCFC.png"
              height={30}
              width={30}
              className="h-8 w-8 rounded-md border border-border dark:border-neutral-700"
            />
            <p className="font-semibold text-foreground dark:text-neutral-100 text-md">Novus CFC</p>
          </div>

          <div className="max-w-2xl flex flex-col gap-3">
            <h1 className="text-2xl sm:text-5xl font-bold text-foreground dark:text-neutral-100 leading-tight">
              Agende suas aulas com rapidez e clareza
            </h1>
            <p className="text-sm sm:text-base text-muted-foreground dark:text-neutral-300">
              Plataforma da autoescola para alunos e instrutores acompanharem agendamentos, horários e rotina de aulas em um fluxo simples.
            </p>
          </div>
        </header>

        <section className="grid grid-cols-1 lg:grid-cols-[1.2fr_0.9fr] gap-6 items-stretch">
          <div className="border border-border dark:border-neutral-700 rounded-2xl p-6 flex flex-col justify-between gap-6 bg-background/60 dark:bg-neutral-900/40">
            <div className="flex flex-col gap-3 text-left">
              <h2 className="text-2xl font-bold text-foreground dark:text-neutral-100">
                Entrar no sistema
              </h2>
              <p className="text-sm text-muted-foreground dark:text-neutral-300">
                Escolha seu perfil para continuar. Ambos os acessos direcionam para a mesma tela de login.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <button
                type="button"
                aria-label="Entrar como aluno"
                className="h-14 sm:h-16 text-lg font-semibold rounded-xl bg-primary text-white border border-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary/70 transition"
                onClick={() => navigate('/login')}
              >
                Entrar aluno
              </button>
              <button
                type="button"
                aria-label="Entrar como instrutor"
                className="h-14 sm:h-16 text-lg font-semibold rounded-xl bg-secondary text-white border border-secondary hover:bg-secondary/90 focus:outline-none focus:ring-2 focus:ring-secondary/70 transition"
                onClick={() => navigate('/login')}
              >
                Entrar instrutor
              </button>
            </div>
          </div>

          <aside className="border border-border dark:border-neutral-700 rounded-2xl p-6 bg-card dark:bg-neutral-800 flex flex-col gap-3">
            <h3 className="text-xl font-semibold text-foreground dark:text-neutral-100">
              O que você encontra aqui
            </h3>
            <p className="text-sm text-muted-foreground dark:text-neutral-300">
              Agendamento organizado para reduzir conflitos e facilitar o dia a dia.
            </p>
            <div className="flex flex-col gap-2 text-sm text-foreground dark:text-neutral-100">
              <p className="border-l-4 border-primary pl-3">Consulta de horários de aula</p>
              <p className="border-l-4 border-secondary pl-3">Fluxo guiado de agendamento</p>
              <p className="border-l-4 border-primary pl-3">Visão dedicada para aluno e instrutor</p>
            </div>
          </aside>
        </section>

        <footer className="pt-2 border-t border-border dark:border-neutral-700 text-xs text-muted-foreground dark:text-neutral-400 flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-2">
          <p>Feito por NovusTech</p>
          <img className="w-4 h-4" src="logoNovusTech.png" alt="NovusTech logo" />
        </footer>
      </article>
    </main>
  );
}
